import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import associateServices from "../../services";
import Loading from "../../components/loading";

const Trade = () => {
    const {selectedWallet} = useSelector(state => state.authenticationReducer)
    const {agent} = useSelector(state => state.globalReducer)
    const [loading, setLoading] = useState(true)
    const [url, setUrl] = useState('')

    useEffect(() => {
        setLoading(true)
        const value = {
            code: selectedWallet?.code,
        }
        associateServices.getTradeUrl(value).then(res => {
            if (res?.status === 200) {
                setUrl(res?.data)
                setLoading(false)
            }
        })
    }, [selectedWallet?.code])


    useEffect(() => {
        const mainElement = document.getElementById('main')
        const headerElement = document.getElementById('header')
        const sidebarElement = document.getElementById('sidebar')
        const footerElement = document.getElementById('footer')
        mainElement?.classList?.add('main--sport')
        headerElement?.classList?.add('header--sport')
        if (!agent?.isMobile)
            sidebarElement?.classList?.add('active')
        footerElement?.classList?.add('footer--sport')
        return () => {
            mainElement?.classList?.remove('main--sport')
            headerElement?.classList?.remove('header--sport')

            if (!agent?.isMobile)
                sidebarElement?.classList?.remove('active')
            footerElement?.classList?.remove('footer--sport')

        }
    }, [])


    return (
        <div className="section  pt-0">
            <div className="row">
                <div className="col-12">
                    <div className="frame frame--full">
                        <div className="frame__cover">
                            {
                                loading ? <Loading/> :
                                    <iframe
                                        src={url}
                                        id="game"
                                        frameBorder={0}
                                        allowFullScreen
                                        width={'100%'}
                                        height={'100%'}
                                        scrolling={'yes'}
                                    />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )


}

export default Trade
